var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCard = function SvgCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.334 6.292c0 .55-.45 1-1 1H2.667c-.55 0-1-.45-1-1v-.008a3.446 3.446 0 0 1 3.45-3.45h9.758a3.46 3.46 0 0 1 3.459 3.458M1.667 9.541v4.175a3.446 3.446 0 0 0 3.45 3.45h9.758a3.46 3.46 0 0 0 3.459-3.458V9.54c0-.55-.45-1-1-1H2.667c-.55 0-1 .45-1 1m5 4.833H5a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h1.667a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625m5.417 0H8.75a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h3.334a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625"
  })));
};
export default SvgCard;